export const BETA_REVENUECAT_BYPASS_DISABLE_KEY = '__E2E_DISABLE_BETA_REVENUECAT_BYPASS__';

// Temporary June 2026 beta access: keep testers out of RevenueCat gating while
// trainer/client onboarding is being validated.
const BETA_REVENUECAT_BYPASS_ENABLED = true;

export function isBetaRevenueCatBypassEnabled(): boolean {
  if (!BETA_REVENUECAT_BYPASS_ENABLED) {
    return false;
  }

  if (typeof window === 'undefined') {
    return true;
  }

  try {
    return window.localStorage.getItem(BETA_REVENUECAT_BYPASS_DISABLE_KEY) !== 'true';
  } catch {
    return true;
  }
}
